// extracted by mini-css-extract-plugin
export default {"container":"PJU9KHuiwfChdvnEVAL4","body":"ukUym2D_ptCtV7GdQCsV"};